import { create } from 'zustand';
import dayjs from 'dayjs';
import moment from 'moment-timezone';

import apiCore from '../utils/api-core';

const defaultSettings = {
    dateRange: [dayjs().subtract(30, 'days'), dayjs()],
    timezone: moment.tz.guess() || 'UTC',
    groupBy: 'auto',
};

const defaultKpis = {
    inboundMsg:   { value: 0, change: 0 },
    outboundMsg:  { value: 0, change: 0 },
    usersCount:   { value: 0, change: 0 },
    contacts:     { value: 0, change: 0 },
    interviews:   { value: 0, change: 0 },
    scheduled:    { value: 0, change: 0 },
};

// ─── Store ─────────────────────────────────────────────────────────────────────

const useDashboardStore = create((set, get) => ({
    // Loading
    loading: false,

    // Filters
    filters: defaultSettings,

    // Data
    kpis: defaultKpis,
    interviews: [],
    scheduledPerMonth: [],
    newContacts: [],
    messagingVolume: [],
    outboundPerUser: [],

    // Actions
    setFilters: (newFilters) => {
        set((state) => ({
            filters: { ...state.filters, ...newFilters },
        }));
    },

    fetchDashboard: async (companyId) => {
        if (!companyId) return;
        const { filters } = get();
        
        set({ loading: true });
        try {
            const start = filters.dateRange && filters.dateRange[0] ? filters.dateRange[0].format('YYYY-MM-DD') : null;
            const end = filters.dateRange && filters.dateRange[1] ? filters.dateRange[1].format('YYYY-MM-DD') : null;
            
            const reqUrl = `/api/v3/company/${companyId}/dashboard`;
            const { data: response } = await apiCore.get(reqUrl, { 
                params: { startDate: start, endDate: end, timezone: filters.timezone, groupBy: filters.groupBy } 
            });

            // The backend responds directly with the object data
            if (response) {
                set({
                    kpis: response.kpis || defaultKpis,
                    interviews: response.interviews || [],
                    scheduledPerMonth: response.scheduledPerMonth || [],
                    newContacts: response.newContacts || [],
                    messagingVolume: response.messagingVolume || [],
                    outboundPerUser: response.outboundPerUser || [],
                    loading: false,
                });
            } else {
                set({ loading: false });
            }
        } catch (error) {
            console.error('Failed to fetch dashboard metrics:', error);
            set({ loading: false });
        }
    },
}));

export default useDashboardStore;
